__webpack_require__.p = "/assets/turbo/5f7393d0/ottonl/_next/";